<template>
    <div class="me">
        <div class="placeholder"></div>
        <div class="me-content me-warp">
            <div class="me-user">
                <img src="../../assets/img/me/icon.png" alt="">
                <div class="me-user-r">
                    <div class="name">
                        {{openid.slice(0,4)}}***{{openid.slice(-4)}}
                        <img :src="vipicon" alt="" style="width:44px"> 
                        <!-- <div>
                             <img :src="vipicon" alt=""> 
                        </div> -->
                    </div>
                    <div class="ui">
                        UID：
                        <span> {{uid}}</span>&nbsp;&nbsp;
                        <img src="../../assets/img/me/icon2.png" alt="" @click="copyto()">
                    </div>
                    <div class="recommend">
                        {{$t('me.recommend')}}：
                        <span>{{recommend}}</span>
                    </div>
                </div>
            </div>

            <div class="me-card">
                <div>
                    <div>
                        <div class="value">
                            {{myAmount}}<span></span>
                        </div>
                        <div class="label">{{$t('me.subscription')}}(USDT)</div>
                    </div>
                    <div>
                        <div class="value">
                            {{shareAmount}}<span></span>
                        </div>
                        <div class="label">{{$t('me.directReferral')}}(USDT)</div>
                    </div>
                </div>
                <div>
                    <div>
                        <div class="value">
                            {{teamCount}}<span></span>
                        </div>
                        <div class="label">{{$t('me.team')}}</div>
                    </div>
                    <div>
                        <div class="value">
                            {{teamAmount}}<span></span>
                        </div>
                        <div class="label">{{$t('me.performance')}}(USDT)</div>
                    </div>
                </div>
            </div>

            <div class="me-list">
                <div>
                    <div>{{$t('me.serialNumber')}}</div>
                    <div>{{$t('me.level')}}</div>
                    <div>{{$t('me.individual')}}</div>
                    <div>{{$t('me.performance')}}</div>
                    <div>{{$t('me.time')}}</div>
                </div>
                <div v-for="(item,i) in pagelist" :key="i" >
                    <div>{{item.uid}}</div>
                    <div>P{{item.vip}}</div>
                    <div>{{item.myAmount}}</div>
                    <div>{{item.teamAmount}}</div>
                    <div>{{formatTime(item.AddTime)}}</div>
                </div>
            </div>

            <div class="me-page">
                <img src="../../assets/img/me/arrow-l.png" alt="">
                <div @click="prevPage()">{{$t('me.home')}}</div>
                <div class="page">
                </div>
                <div @click="nextPage()">{{$t('me.last')}}</div>
                <img src="../../assets/img/me/arrow-r.png" alt="">
            </div>
        </div>

    </div>
</template>

<script>
import {
    Field,
    Swipe,
    SwipeItem,
    Circle,
    Tab,
    Tabs,
    Popup,
    Progress,
    Button,
} from "vant";
import { copyToClipboard } from "@/utils";
import NumberScroll from "@/components/NumberScroll.vue";
import SplitText from "@/components/SplitText/SplitText.vue";
import ShinyText from "@/components/ShinyText/ShinyText.vue";
import AnimatedContent from "@/components/AnimatedContent/AnimatedContent.vue";
import FadeContent from "@/components/FadeContent/FadeContent.vue";

import axios from 'axios'
import contractaa from '../contract/index.js'

export default {
    name: "me",
    components: {
        SplitText,
        ShinyText,
        AnimatedContent,
        FadeContent,
        Field,
        Swipe,
        SwipeItem,
        Tab,
        VanCircle: Circle,
        Tabs,
        Popup,
        Progress,
        Button,
        NumberScroll,
    },
    data() {
        return {
            value: "1",
            show: false,
            value1: '100',
            value2: '134.5',
            value3: '134.5',
            currentPage:1,
            openid:'',
            uid:'',
            recommend:'',
            myAmount:0,
            shareAmount:0,
            teamCount:0,
            teamAmount:0,
            vip:0,
            pagelist:[],
            vipicon:require('@/assets/img/me/p0.png')
        };
    },
    computed: {},

    methods: {
        getInfo(page){
            let that = this;
            let _token = this.$store.state.loginToken
            _token = encodeURIComponent(_token)
            axios.post(contractaa.APIURL+'?cmd=me','token='+ _token+'&page='+page).then(function (response) {
            if (response.status === 200) {
                    if(response.data.Status){
                        let _vlist = response.data.Message.split('|')
                        that.openid = _vlist[0]
                        that.uid = _vlist[1]
                        that.recommend = _vlist[2]
                        that.vip = _vlist[3]
                        
                        that.myAmount = _vlist[4]
                        that.shareAmount = _vlist[5]
                        that.teamCount = _vlist[6]
                        that.teamAmount = _vlist[7]
                        that.pagelist = response.data.Data

                        if(that.vip == 0){
                            that.vipicon = require('@/assets/img/me/p0.png')
                        }else if(that.vip == 1){
                            that.vipicon = require('@/assets/img/me/p1.png')
                        }else if(that.vip == 2){
                            that.vipicon = require('@/assets/img/me/p2.png')
                        }else if(that.vip == 3){
                            that.vipicon = require('@/assets/img/me/p3.png')
                        }else if(that.vip == 4){
                            that.vipicon = require('@/assets/img/me/p4.png')
                        }else if(that.vip == 5){
                            that.vipicon = require('@/assets/img/me/p5.png')
                        }else if(that.vip == 6){
                            that.vipicon = require('@/assets/img/me/p6.png')
                        }
                    }

                }
            })
        },
        formatTime(timeStr){
            let clean = timeStr.replace('T',' ').slice(5, -12)
            return clean
        },
        copyto(){
            copyToClipboard(this.uid)
            this.$toast.success("复制成功");
        },
        nextPage(){
            this.currentPage = this.currentPage+1;
            this.getInfo(this.currentPage)
        },
        prevPage(){
            if(this.currentPage>1){
                this.currentPage = this.currentPage-1;
                this.getInfo(this.currentPage)
            }
        }
    },
    mounted() {
        let timer = setInterval(async () => {
            if (true) {
                this.getInfo(1)
                clearInterval(timer)
            }
        }, 500);
    },
};
</script>

<style lang="less" scoped>
.me {
    position: relative;

    .placeholder {
        // height: 50px;
    }

    .me-warp {
        padding: 0 20px;
    }

    &-content {
        margin-top: 30px;
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #FFFFFF;

    }

    .me-user {
        display: flex;

        >img {
            width: 66px;
            height: 66px;
            margin-right: 9px;
        }

        &-r {
            .name {
                color: #FFFFFF;
                font-weight: 500;
                font-size: 18px;
                line-height: 16px;
                display: flex;
                align-items: center;
                margin-bottom: 8px;

                >div {
                    margin-left: 6px;
                    width: 47px;
                    height: 22px;
                    background: url('../../assets/img/me/lv.png') no-repeat;
                    background-size: 100% 100%;
                    display: flex;
                    align-items: center;
                    justify-content: flex-end;
                    padding-right: 6px;

                    img {
                        width: 16px;
                        height: 12px;
                    }
                }
            }

            .ui {
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #7E7D87;
                line-height: 17px;
                margin-bottom: 3px;

                span {
                    color: rgba(255, 255, 255, 1);
                }

                img {
                    width: 12px;
                    height: 12px;
                }
            }

            .recommend {
                font-size: 12px;
                line-height: 17px;
                color: #7E7D87;

                span {
                    color: rgba(255, 255, 255, 1);
                }
            }
        }
    }

    .me-card {
        margin-top: 25px;
        height: 140px;
        background: url('../../assets/img/me/card-bg.png') no-repeat;
        background-size: 100% 100%;

        >div {
            display: flex;

            >div {
                flex: 1;
                height: 70x;
                padding: 14px 15px 13px;

                .label {
                    font-weight: 400;
                    color: #838383;
                    line-height: 17px;
                    font-size: 12px;
                }

                .value {
                    font-family: DINAlternate, DINAlternate;
                    font-weight: bold;
                    font-size: 18px;
                    line-height: 21px;
                    color: #FFFFFF;
                    margin-bottom: 5px;

                    span {
                        font-size: 14px;
                    }
                }
            }
        }
    }

    .me-list {
        background: #1B1C1E;
        border-radius: 16px;
        padding: 6px 15px 0;
        margin-top: 15px;

        >div {
            padding-top: 9px;
            display: flex;
            padding-bottom: 10px;

            >div {
                width: 25%;
                font-size: 12px;
                line-height: 17px;
                color: #838383;
                text-align: center;
                font-weight: 400;
                padding: 0 1px;
            }

            >div:first-child {
                text-align: left;
            }

            >div:last-child {
                text-align: right;
            }

        }

        >div+div {
            border-top: 1px solid rgba(151, 151, 151, 0.1);

            >div {
                color: #FFFFFF;
            }
        }
    }

    .me-page {
        display: flex;
        align-items: center;
        color: #FFFFFF;
        font-size: 14px;
        line-height: 20px;
        margin-top: 20px;
        >img {
            width: 10px;
            height: 10px;
        }
        >img:first-child {
            margin-right: 5px;
        }
        >img:last-child {
            margin-left: 5px;
        }
        .page {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            >div {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 36px;
                height: 26px;
                border-radius: 6px;
                color: #838383;
                &.active {
        background: #FFFFFF;
        color: #1A130B;
        font-weight: 500;
                }
            }
            >div + div {
                margin-left: 8px;
            }
        }

    }

}
</style>
<style lang="less"></style>